import React from 'react'
import { Stack, MenuItem, Button, Menu } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'
import { Log } from '../../types/log'
import CompareIcon from '../../svgicons/compare'
import MenuItemField from './MenuItemField'
import { CheckBoxOutlineBlank, KeyboardArrowDown, LocalCafe } from '@mui/icons-material'

interface selectTableHeadProps {
  selectedLogs: Log[]
  handleUncheck(): void
  handleCompare(): void
  handleCupping(): void
  handleDelete(): void
}

const SelectTableHead = (props: selectTableHeadProps): JSX.Element => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState<boolean>(false)
  const [disabled, setDisabled] = React.useState<boolean>(true)
  const [compare_disabled, setCompare_disabled] = React.useState<boolean>(true)

  React.useEffect(() => {
    if (props.selectedLogs.length < 1) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
    if (props.selectedLogs.length < 2) {
      setCompare_disabled(true)
    } else {
      setCompare_disabled(false)
    }
  }, [props.selectedLogs])

  const handleUnselect = () => {
    props.handleUncheck()
    setOpen(false)
  }

  const handleDelete = () => {
    props.handleDelete()
    setOpen(false)
  }

  const handleCompare = () => {
    props.handleCompare()
    setOpen(false)
  }

  const handleCupping = () => {
    props.handleCupping()
    setOpen(false)
  }
  return (
    <Stack direction={'row-reverse'} sx={{ display: disabled ? 'none' : undefined }}>
      <Button
        onClick={() => setOpen(true)}
        id="bulk_op"
        sx={{
          textTransform: 'capitalize',
          minWidth: 'auto',
        }}
        endIcon={<KeyboardArrowDown />}
        variant="contained"
      >
        {t('logview.bulkoperations')}
      </Button>
      <Menu open={open} onClose={() => setOpen(false)} anchorEl={document.getElementById('bulk_op')}>
        <MenuItem
          onClick={handleCompare}
          disabled={compare_disabled}
          sx={{ minWidth: 200, textDecoration: 'underline' }}
        >
          <MenuItemField label={t('logview.comparelogs')} icon={<CompareIcon sx={{ mr: 2.5 }} />} />
        </MenuItem>
        <MenuItem onClick={handleCupping} sx={{ textDecoration: 'underline' }}>
          <MenuItemField label={t('logview.cupping')} icon={<LocalCafe sx={{ mr: 2.5 }} />} />
        </MenuItem>
        <MenuItem onClick={handleUnselect}>
          <MenuItemField label={t('logview.unselectall')} icon={<CheckBoxOutlineBlank sx={{ mr: 2.5 }} />} />
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <MenuItemField label={t('logview.delete')} icon={<DeleteIcon sx={{ mr: 2.5 }} />} />
        </MenuItem>
      </Menu>
    </Stack>
  )
}
export default SelectTableHead
